import { PageHeader, Space, message, Spin } from "antd";
import { tabStyles } from "../../../../Components/TabbedDynamicTable";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { ButtonItem, ModalItem } from "../../../../Components/Items";
import { SaveOutlined, ArrowLeftOutlined, EyeOutlined, EditOutlined, WarningOutlined } from "@ant-design/icons";
import ProcesoForm from "../ProcesoForm/ProcesoForm";

/*
  Modo determinado por location.state:
    - Sin id                  → Agregar
    - { id, modo: "editar" }  → Editar
    - { id, modo: "ver" }     → Ver (solo lectura)
*/
class VistaProceso extends Component {
  procesoFormRef = React.createRef();

  state = {
    guardando: false,
    cargando: false,
    cantidadDerivados: 0,
    procesoData: null,
    modalActualizarHijos: false,
    pendienteGuardado: null,
  };

  get modo() {
    return this.props.location?.state?.modo || "agregar";
  }

  get procesoId() {
    return this.props.location?.state?.id || null;
  }

  componentDidMount() {
    if (this.procesoId) {
      this.setState({ cargando: true });
      axios
        .post(
          "proceso/datosProceso",
          { empresaId: this.props.empresaId, procesoId: this.procesoId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            console.log(res.data)
            if (this.procesoFormRef.current) {
              this.procesoFormRef.current.setInitialValues(res.data.data);
            }
            this.setState({
              cantidadDerivados: res.data.data.cantidadDerivados || 0,
              procesoData: res.data.data,
            });
          } else {
            message.error(res.data.message || "Error al cargar el proceso");
            this.props.history.goBack();
          }
        })
        .catch(() => {
          message.error("Error de conexión");
          this.props.history.goBack();
        })
        .finally(() => this.setState({ cargando: false }));
    }
  }

  async guardar() {
    let data;
    try {
      data = await this.procesoFormRef.current.getData();
    } catch {
      return;
    }

    const { proceso, puntos } = data;
    const procesoConId = this.modo === "editar"
        ? { ...proceso, _id: this.procesoId }
        : proceso;

    if (this.modo === "editar" && proceso.esPlantilla && this.state.cantidadDerivados > 0) {
      this.setState({
        modalActualizarHijos: true,
        pendienteGuardado: { procesoConId, puntos },
      });
      return;
    }

    this.ejecutarGuardado(procesoConId, puntos, false);
  }

  cerrarModalPropagacion() {
    this.setState({ modalActualizarHijos: false, pendienteGuardado: null });
  }

  confirmarPropagacion(actualizarHijos) {
    const { pendienteGuardado } = this.state;
    this.setState({ modalActualizarHijos: false, pendienteGuardado: null });
    if (pendienteGuardado) {
      this.ejecutarGuardado(pendienteGuardado.procesoConId, pendienteGuardado.puntos, actualizarHijos);
    }
  }

  ejecutarGuardado(procesoConId, puntos, actualizarHijos) {
    this.setState({ guardando: true });

    const payload = {
      empresaId: this.props.empresaId,
      usuarioId: this.props.usuarioId,
      proceso: { ...procesoConId, puntos },
      actualizarHijos,
    };

    axios
      .post("proceso/guardarProceso", payload, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          message.success(
            this.modo === "editar"
              ? "Proceso actualizado correctamente"
              : "Proceso guardado correctamente"
          );
          this.props.history.push("/panel/calidad");
        } else {
          message.error(res.data.message || "Error al guardar el proceso");
        }
      })
      .catch(() => message.error("Error de conexión"))
      .finally(() => this.setState({ guardando: false }));
  }

  render() {
    const { guardando, cargando } = this.state;
    const modo = this.modo;
    const soloLectura = modo === "ver";

    const titulos = {
      agregar: "Agregar Proceso",
      editar: "Editar Proceso",
      ver: "Ver Proceso",
    };

    const iconoHeader = soloLectura ? <EyeOutlined /> : <EditOutlined />;

    return (
      <Spin spinning={guardando || cargando}>
        <PageHeader
          title={titulos[modo] || "Proceso"}
          onBack={() => this.props.history.goBack()}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            !soloLectura
              ? [
                  <ButtonItem
                    key="guardar"
                    type="primary"
                    icon={<SaveOutlined />}
                    loading={guardando}
                    onClick={() => this.guardar()}
                  >
                    {modo === "editar" ? "Guardar Cambios" : "Guardar Proceso"}
                  </ButtonItem>,
                ]
              : [
                  <ButtonItem
                    key="editar"
                    icon={iconoHeader}
                    onClick={() =>
                      this.props.history.replace("/panel/editarProceso", {
                        id: this.procesoId,
                        modo: "editar",
                      })
                    }
                  >
                    Editar
                  </ButtonItem>,
                ]
          }
        />

        <style>{tabStyles}</style>
        <div style={{ borderRadius: "8px", backgroundColor: "white", padding: "20px" }}>
          <ProcesoForm ref={this.procesoFormRef} disabled={soloLectura} initialValues={this.state.procesoData} />

          <div style={{ textAlign: "right", marginTop: 24 }}>
            <Space>
              <ButtonItem
                icon={<ArrowLeftOutlined />}
                onClick={() => this.props.history.goBack()}
              >
                {soloLectura ? "Regresar" : "Cancelar"}
              </ButtonItem>
              {!soloLectura && (
                <ButtonItem
                  type="primary"
                  icon={<SaveOutlined />}
                  loading={guardando}
                  onClick={() => this.guardar()}
                >
                  {modo === "editar" ? "Guardar Cambios" : "Guardar Proceso"}
                </ButtonItem>
              )}
            </Space>
          </div>
        </div>

        <ModalItem
          title="Actualizar procesos derivados"
          visible={this.state.modalActualizarHijos}
          onCancel={() => this.cerrarModalPropagacion()}
          spinning={false}
          width={480}
        >
          <p style={{ marginTop: 12 }}>
            Esta plantilla tiene <b>{this.state.cantidadDerivados}</b> proceso(s) derivado(s).
            ¿Deseas guardar solo esta plantilla o también actualizar los procesos derivados?
          </p>
          <div style={{
            display: "flex",
            gap: 8,
            alignItems: "flex-start",
            backgroundColor: "#fffbe6",
            border: "1px solid #ffe58f",
            borderRadius: 6,
            padding: "8px 12px",
            marginBottom: 16,
          }}>
            <WarningOutlined style={{ color: "#d48806", marginTop: 3 }} />
            <span style={{ fontSize: 13, color: "#664d03" }}>
              Si actualizas los derivados se sobrescribirá su descripción, reglas de programación,
              prioridad, metadatos <b>y también sus puntos/pasos del procedimiento</b> con los de esta
              plantilla. El <b>nombre</b> y los <b>responsables</b> de cada proceso derivado no se modifican.
            </span>
          </div>
          <Space style={{ width: "100%", justifyContent: "flex-end" }}>
            <ButtonItem onClick={() => this.confirmarPropagacion(false)}>
              Guardar solo plantilla
            </ButtonItem>
            <ButtonItem type="primary" verde onClick={() => this.confirmarPropagacion(true)}>
              Guardar y actualizar derivados
            </ButtonItem>
          </Space>
        </ModalItem>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
});

export default connect(mapStateToProps)(VistaProceso);
